import React from 'react';
import IconBase from './IconBase';

const DeleteIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M9.4,16.5l2.6-2.6,2.6,2.6,1.4-1.4-2.6-2.6,2.6-2.6-1.4-1.4-2.6,2.6-2.6-2.6-1.4,1.4,2.6,2.6-2.6,2.6,1.4,1.4ZM7,21c-.55,0-1.02-.2-1.41-.59-.39-.39-.59-.86-.59-1.41V6h-1v-2h5v-1h6v1h5v2h-1v13c0,.55-.2,1.02-.59,1.41-.39.39-.86.59-1.41.59H7ZM17,6H7v13h10V6ZM7,6v13V6Z"/>
        </IconBase>
    )
}

export default DeleteIcon;